import CTooltip from "./CTooltip"
import type { HintContent } from "./HintDataContent"
import { HintDataContent } from "./HintDataContent"
import { HintIcon } from "@shared/icons"
import type { ReactNode } from "react"
import { memo } from "react"
import useDevice from "@shared/hooks/useDevice"

interface IProps {
  content: HintContent
  wrapClass?: string
  iconContent?: ReactNode
  placement?: "left" | "right" | "top" | "bottom" | undefined
}

const CHintWithTooltipComponent = ({ content, wrapClass, iconContent, placement }: IProps) => {
  const { isMobile } = useDevice()

  return (
    <span className={`${wrapClass || ""} ml-1 cursor-pointer inline-flex items-center`}>
      <CTooltip
        tooltipClassName="p-2 pb-0"
        placement={placement || (isMobile ? "bottom" : "right")}
        arrow={false}
        content={<HintDataContent content={content} />}
      >
        {iconContent || <HintIcon />}
      </CTooltip>
    </span>
  )
}

export const CHintWithTooltip = memo(CHintWithTooltipComponent)
CHintWithTooltip.displayName = "CHintWithTooltip"
